<template>
  <div class="full-height">
    <Spinner v-if="loading" />

    <div v-else-if="localConfig && localConfig.campaignData" class="full-height">
      <Card class="full-height">
        <!-- Computed Name -->
        <div class="row">
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--large col">
              <Input
                  :label="$t('campaignDesigner.campaignSetup.namecomputed')"
                  :disabled="true"
                  ref="namecomputed"
                  v-if="isCreate || isEdit"
                  v-model="namecomputed" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.namecomputed')"
                  :value="namecomputed"
                  v-else />
            </div>
          </div>
        </div>
        <!-- Name, type -->
        <div class="row">
          <!-- Name -->
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.name')"
                :maxlength="50"
                :validation="['required', {name:'max-length', param: 50}]"
                ref="data_name"
                v-if="isCreate || isEdit"
                v-model="name" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.name')"
                :value="name"
                v-else />
            </div>
          </div>

          <!-- Campaign type selection -->
          <div class="slds-form-element slds-size--medium col">
            <CampaignTypeSelector
              ref="data_campaignType"
              v-if="isCreate && localConfig.campaignData.type.options.length > 1"
              v-model="campaignType"
              :options="localConfig.campaignData.type.options"
              :sortLabel=true
              :validation="['required']" />

            <OutputField :label="$t('campaignDesigner.campaignSetup.type.label')" type="custom" v-else>
              <span class="slds-swatch type-color-container" :style="`background:${campaignType.color ? campaignType.color: '#FFFFFF'};`" />
              <span>{{campaignType.label}}</span>
            </OutputField>
          </div>
        </div>

        <!-- Campaign Category, Business Area -->
        <div class="row">
          <!-- Campaign Category-->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.campaigncategory.label')"
              :disabled="isVHR"
              :options="localConfig.campaignData.campaigncategory.options"
              :validation="['required']"

              labels-prefix="campaignDesigner.campaignSetup.campaigncategory"
              ref="data_campaigncategory"
              v-if="(isCreate || isEdit)"
              v-model="campaigncategory" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.campaigncategory.label')"
              :options="localConfig.campaignData.campaigncategory.options"
              :value="campaigncategory"
              labels-prefix="campaignDesigner.campaignSetup.campaigncategory"
              type="picklist"
              v-else />
          </div>

          <!-- Business Area -->
          <div class="slds-form-element slds-size--medium col" v-if="!this.isVHR">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.BusinessArea.label')"
              :options="this.business_area_options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.BusinessArea"
              ref="data_business_area"
              v-if="(isCreate || isEdit)"
              v-model="business_area" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.BusinessArea.label')"
              :options="this.business_area_options"
              :value="business_area"
              type="picklist"
              labels-prefix="campaignDesigner.campaignSetup.BusinessArea"
              v-else />
          </div>
        </div>

        <!-- Market, Channels -->
        <div class="row">
          <!-- Market -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :can-remove-elements="!isVHR"
              :label="$t('campaignDesigner.campaignSetup.market')"
              :hide-picklist="isVHR"
              :options="localConfig.campaignData.markets.options"
              :validation="['required']"
              :sortLabel=true
              include-all-value
              searchable
              labels-prefix="markets"
              multipicklist
              ref="data_markets"
              v-if="(isCreate || isEdit)"
              v-model="markets" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.market')"
              :options="localConfig.campaignData.markets.options"
              :value="markets"
              labels-prefix="markets"
              type="multipicklist"
              v-else />
          </div>

          <!-- Channels -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.channels.label')"
              :options="localConfig.campaignData.campaignChannel.options"
              :validation="['required']"
              labels-prefix="channels"
              multipicklist
              ref="data_channels"
              v-if="(isCreate || isEdit) && !isVHR"
              v-model="campaignChannel" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.channels.label')"
              :options="localConfig.campaignData.campaignChannel.options"
              :value="campaignChannel"
              labels-prefix="channels"
              type="multipicklist"
              v-else />
          </div>

        </div>

        <!-- Business Type, Main Target -->
        <div class="row">
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.businesstype.label')"
              :options="localConfig.campaignData.businesstype.options"
              :validation="['required']"
              :sortLabel=true
              labels-prefix="campaignDesigner.campaignSetup.businesstype"
              ref="data_businesstype"
              v-if="(isCreate || isEdit)"
              v-model="businesstype" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.businesstype.label')"
              :options="localConfig.campaignData.businesstype.options"
              :value="businesstype"
              labels-prefix="campaignDesigner.campaignSetup.businesstype"
              type="picklist"
              v-else />
          </div>

          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.maintarget.label')"
              :options="localConfig.campaignData.maintarget.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.maintarget"
              ref="data_maintarget"
              v-if="(isCreate || isEdit)"
              :disabled="isVHR"
              v-model="maintarget" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.maintarget.label')"
              :options="localConfig.campaignData.maintarget.options"
              :value="maintarget"
              labels-prefix="campaignDesigner.campaignSetup.maintarget"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Start date, End date -->
        <div class="row">
          <!-- Start date -->
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.startDate')"
                :validation="[{name: 'is-date-before', param: endDate}, 'is-date-after-today', 'required']"
                ref="data_startDate"
                type="date"
                v-if="isCreate || isEdit"
                v-model="startDate" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.startDate')"
                :value="startDate"
                type="date"
                v-else />
            </div>
          </div>

          <!-- End date -->
          <div class="slds-form-element slds-size--medium col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :disabled="isContactPlan(campaignType.label) || isVHR"
                :label="$t('campaignDesigner.campaignSetup.endDate')"
                :validation="isContactPlan(campaignType.label) || isVHR ? [] : [isSales ? '' : 'required', 'is-date-after-today']"
                ref="data_endDate"
                type="date"
                v-if="isCreate || isEdit"
                v-model="endDate" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.endDate')"
                :value="endDate"
                type="date"
                v-else />
            </div>
          </div>
        </div>

        <!-- Brands, Masterkey campaign -->
        <div class="row">
          <!-- Brands -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :can-remove-elements="!isVHR"
              :hide-picklist="isVHR"
              :label="$t('campaignDesigner.campaignSetup.brands')"
              :options="brandOptions"
              :validation="['required']"
              :sortLabel=true
              :include-all-value="brandOptions.length > 0"
              labels-prefix="brands"
              multipicklist
              ref="data_brands"
              v-if="(isCreate || isEdit)"
              v-model="campaignBrands" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.brands')"
              :options="brandOptions"
              :value="campaignBrands"
              labels-prefix="brands"
              type="multipicklist"
              v-else />
          </div>
          <!-- Masterkey campaign -->
          <div class="slds-form-element slds-size--medium col" v-if="masterKeys">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.masterKey')"
              :options="masterKeys"
              :validation="((isSales || isTechnical || !hasBrandExF) || (!isBusAreaAftersales)) ? [] : ['required']"
              :show-empty-value="masterKeys.length > 0"
              ref="data_masterkey"
              searchable
              v-if="isCreate || isEdit"
              v-model="masterKey" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.masterKey')"
              :value="masterKey"
              type="custom"
              v-else>

              <span v-if="masterKeys && masterKeys.length && masterKey">{{masterKey.length && masterKeys.find(mk => mk.value === masterKey).label}}</span>
            </OutputField>
          </div>
        </div>

        <!-- Process Type, Contribution Type -->
        <div class="row">
          <!-- Process Type -->
          <div class="slds-form-element col slds-size--medium" v-if="!isVHR" >
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.processtype.label')"
              :options="localConfig.campaignData.processtype.options"
              :validation="[]"
              :sortLabel=true
              labels-prefix="campaignDesigner.campaignSetup.processtype"
              ref="data_processtype"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="processtype" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.processtype.label')"
              :options="localConfig.campaignData.processtype.options"
              :value="processtype"
              labels-prefix="campaignDesigner.campaignSetup.processtype"
              type="picklist"
              v-else />
          </div>

          <!-- Contribution Type -->
          <div class="slds-form-element col slds-size--medium" v-if="!isVHR && !isSales && hasBrandExF">
            <GenericFilter
              filter-type="included"
              is-picklist
              labels-prefix="campaignDesigner.campaignSetup.contributionType"
              v-if="isCreate || isEdit"
              v-model="contributionType"
              :default-value="contributionTypeDefault"
              :options="localConfig.campaignData.contributionType.options"
              :label="$t('campaignDesigner.campaignSetup.contributionType.label')" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.contributionType.label')"
              :options="localConfig.campaignData.contributionType.options"
              :value="contributionType"
              labels-prefix="campaignDesigner.campaignSetup.contributionType"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Segment Type, Legal Base, Orchestration -->
        <div class="row slds-m-top--xx-small">
          <!-- Segment Type -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.segmentType.label')"
              :options="localConfig.campaignData.segmentType.options"
              :validation="isSales ? [] : ['required']"
              :sortLabel=true
              labels-prefix="campaignDesigner.campaignSetup.segmentType"
              ref="data_segmentType"
              show-empty-value
              v-if="isCreate || isEdit"
              :disabled="isVHR"
              v-model="segmentType" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.segmentType.label')"
              :options="localConfig.campaignData.segmentType.options"
              :value="segmentType"
              labels-prefix="campaignDesigner.campaignSetup.segmentType"
              type="picklist"
              v-else />
          </div>

          <div class="slds-form-element slds-size--medium col" v-if="this.localConfig.campaignData.legalBase && !this.isVHR">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.legalBase.label')"
              :options="localConfig.campaignData.legalBase.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.legalBase"
              ref="data_legalBase"
              v-if="isCreate || isEdit"
              v-model="legalBase" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.legalBase.label')"
              :options="localConfig.campaignData.legalBase.options"
              :value="legalBase"
              labels-prefix="campaignDesigner.campaignSetup.legalBase"
              type="picklist"
              v-else />
          </div>

          <!-- Orchestration -->
          <!-- <div class="slds-form-element col slds-size--medium" v-if="hasBrandExF && recordType!='full'" >
            <OutputField
              :label="$t('campaignDesigner.targetDefinition.disableOrchestration')"
              :value="disableOrchestration"
              type="checkbox"
              v-if="!(isCreate || isEdit) || !disableOrchestrationEditable || isVHR" />

            <Input
              :label="$t('campaignDesigner.targetDefinition.disableOrchestration')"
              type="checkbox"
              v-else
              v-model="disableOrchestration" />

          </div> -->
        </div>

        <!-- Content Classification, Finality / CCDB Report Enabled -->
        <div class="row">

          <!-- Finality -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.finality.label')"
              :options="localConfig.campaignData.finality.options"
              :tooltip="finalityTooltip"
              :validation="isSales ? [] : ['required']"
              :sortLabel=true
              tooltip-direction="right"
              labels-prefix="campaignDesigner.campaignSetup.finality"
              ref="data_finality"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="finality" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.finality.label')"
              :options="localConfig.campaignData.finality.options"
              :value="finality"
              labels-prefix="campaignDesigner.campaignSetup.finality"
              type="picklist"
              v-else />
          </div>

          <!-- Content Classification -->
          <div class="slds-form-element col slds-size--medium" v-if="!isSales && hasBrandExF">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.contentClassification.label')"
              :options="localConfig.campaignData.contentClassification.options"
              :validation="(this.onlyHeader && !isBusAreaAftersales) ? [] : ['required']"
              labels-prefix="campaignDesigner.campaignSetup.contentClassification"
              ref="data_contentClassification"
              v-if="isCreate || isEdit"
              v-model="contentClassification" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.contentClassification.label')"
              :options="localConfig.campaignData.contentClassification.options"
              :value="contentClassification"
              labels-prefix="campaignDesigner.campaignSetup.contentClassification"
              type="picklist"
              v-else />
          </div>


          <!-- CCDB Report Enabled -->
          <div class="slds-form-element col slds-size--medium" v-if="isSales">
            <Input
              :label="$t('campaignDesigner.campaignSetup.ccdbReportEnabled')"
              type="checkbox"
              v-if="isCreate || isEdit"
              v-model="ccdbReportEnabled" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.ccdbReportEnabled')"
              :value="ccdbReportEnabled"
              type="checkbox"
              v-else />

          </div>

        </div>

        <!-- Always on, Touchpoint -->
        <div class="row" v-if="!isVHR">
          <div class="slds-form-element col slds-size--medium" v-if="!isSales">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.alwaysOn.label')"
              :options="localConfig.campaignData.alwaysOn.options"
              labels-prefix="campaignDesigner.campaignSetup.alwaysOn"
              ref="data_alwayson"
              v-if="!this.isContactPlan(campaignType.label) && (isCreate || isEdit)"
              v-model="alwaysOn" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.alwaysOn.label')"
              :options="localConfig.campaignData.alwaysOn.options"
              :value="alwaysOn"
              type="picklist"
              labels-prefix="campaignDesigner.campaignSetup.alwaysOn"
              v-else />
          </div>

          <div class="slds-form-element slds-size--medium col" v-if="localConfig.campaignData.touchpoint && !isSales && hasBrandExF">
            <Picklist
              :disabled="!isContactPlan(campaignType.label)"
              :label="$t('campaignDesigner.campaignSetup.touchpoint')"
              :options="localConfig.campaignData.touchpoint.options"
              :required="isCP"
              :validation="[{ name: 'conditional-required', param: isCP, message: 'validation.required'}]"
              ref="data_touchpoint"
              searchable
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="touchpoint" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.touchpoint')"
              :options="localConfig.campaignData.touchpoint.options"
              :value="touchpoint"
              type="picklist"
              v-else />
          </div>

          <!-- CCDB Report Type -->
          <div class="slds-form-element slds-size--medium col" v-if="localConfig.campaignData.ccdbReportType && isSales">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.ccdbReportType.label')"
              :options="localConfig.campaignData.ccdbReportType.options"
              labels-prefix="campaignDesigner.campaignSetup.ccdbReportType"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="ccdbReportType" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.ccdbReportType.label')"
              :options="localConfig.campaignData.ccdbReportType.options"
              :value="ccdbReportType"
              labels-prefix="campaignDesigner.campaignSetup.ccdbReportType"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Camper Contribution, Jeep Wave -->
        <div class="row">
          <!-- Camper Contribution -->
          <div class="slds-form-element col slds-size--medium" v-if="!isVHR && !isSales && hasBrandExF">
            <OutputField
              :label="$t('campaignDesigner.campaignSetup.camperContribution')"
              :value="camperContribution"
              type="checkbox"
              v-if="!(isCreate || isEdit) || !campaignBrands.includes('077')" />

            <Input
              :label="$t('campaignDesigner.campaignSetup.camperContribution')"
              type="checkbox"
              v-else
              v-model="camperContribution" />
          </div>

          <!-- Jeep Wave -->
          <div class="slds-form-element col slds-size--medium" v-if="!isVHR && localConfig.campaignData.jeepWave && campaignBrands.includes('057')" >
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.jeepWave')"
              :options="localConfig.campaignData.jeepWave.options"
              multipicklist
              v-if="isCreate || isEdit"
              v-model="jeepWave" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.jeepWave')"
              :options="localConfig.campaignData.jeepWave.options"
              :value="jeepWave"
              type="multipicklist"
              v-else />
          </div>
        </div>

        <!-- Description, Deduplication -->
        <div class="row slds-m-top--small">
          <!-- Description -->
          <div class="slds-form-element col slds-size--medium">
            <div class="slds-form-element slds-size--medium">
              <TextArea
                :label="$t('campaignDesigner.campaignSetup.description')"
                v-if="isCreate || isEdit"
                v-model="description" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.description')"
                :value="description"
                type="text"
                v-else />
            </div>
          </div>

          <!-- Deduplication -->
          <!-- <div class="slds-form-element col slds-size--medium" v-if="!isSales && recordType!='full'" >
            <template v-if="(isCreate || isEdit)">
              <div class="slds-form-element__control">
                <div class="slds-checkbox">
                  <input type="checkbox" name="options" id="checkbox-deduplication" v-model="deduplicationEnabled" :disabled="isVHR" />
                    <label class="slds-checkbox__label" for="checkbox-deduplication">
                    <span class="slds-checkbox_faux"></span>
                    <span class="slds-form-element__label">{{$t('campaignDesigner.targetDefinition.deduplication.label')}}</span>
                  </label>
                </div>
              </div>
              <RadioGroup
                :disabled="!deduplicationEnabled"
                :options="deduplicationRadioOptions"
                :validation="[{ name: 'conditional-required', param: deduplicationEnabled, message: 'validation.required'}]"
                no-label
                ref="data_deduplicationCriteria"
                v-model="deduplicationCriteria" />

              <Picklist
                :disabled="!deduplicationCriteria"
                :options="localConfig.campaignData.deduplicationParameter.options"
                :validation="[{ name: 'conditional-required', param: deduplicationEnabled, message: 'validation.required'}]"
                labels-prefix="campaignDesigner.targetDefinition.deduplication"
                no-label
                ref="data_deduplicationParameter"
                v-model="deduplicationParameter" />
            </template>

            <template v-else>
              <OutputField :label="$t('campaignDesigner.targetDefinition.deduplication.label')" type="custom">
                <span v-if="deduplicationCriteria">{{$t(`campaignDesigner.targetDefinition.deduplication.${deduplicationCriteria}`)}}</span>
              </OutputField>
              <OutputField no-label type="custom" v-if="deduplicationParameter">
                {{$t(`campaignDesigner.targetDefinition.deduplication.${deduplicationParameter}`)}}
              </OutputField>
            </template>
          </div> -->

          <!-- Manager -->
          <div class="slds-form-element slds-size--medium col" v-if="localConfig.campaignData.manager && isSales">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.manager.label')"
              :options="localConfig.campaignData.manager.options"
              labels-prefix="campaignDesigner.campaignSetup.manager"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="manager" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.manager.label')"
              :options="localConfig.campaignData.manager.options"
              :value="manager"
              labels-prefix="campaignDesigner.campaignSetup.manager"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Selling Online -->
        <div class="row" v-if="!isVHR" >
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.sellingOnline.label')"
              :options="localConfig.campaignData.sellingOnline.options"
              :validation="[]"
              labels-prefix="campaignDesigner.campaignSetup.sellingOnline"
              ref="sellingOnline"
              v-if="(isCreate || isEdit)"
              v-model="sellingOnline" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.sellingOnline.label')"
              :options="localConfig.campaignData.sellingOnline.options"
              :value="sellingOnline"
              labels-prefix="campaignDesigner.campaignSetup.sellingOnline"
              v-else />
          </div>
        </div>

        <!-- Push -->
        <Card additional-classes="slds-card_boundary slds-m-top--small" :title="$t('campaignDesigner.campaignSetup.push')" v-if="campaignChannel.includes('push')">
          <!-- Push list -->
          <div class="row">
            <div class="slds-form-element col">
                <Spinner v-if="!gotAssetLists && (isCreate || isEdit)" style="scale:50%;" />
                <div v-if="gotAssetLists || !(isCreate || isEdit)" >
                  <Picklist
                  :label="$t('campaignDesigner.campaignSetup.push_list')"
                  :options="push_list"
                  :tooltip="$t('campaignDesigner.campaignSetup.push_list_tooltip')"
                  tooltip-direction="right"
                  multipicklist
                  searchable
                  ref="push_list"
                  v-if="(isCreate || isEdit)"
                  v-model="push_selected" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.push_list')"
                  :options="push_selected"
                  :value="push_selected"
                  type="multipicklist"
                  v-else />
                </div>
            </div>
          </div>
        </Card>

        <!-- SMS -->
        <Card additional-classes="slds-card_boundary slds-m-top--small" :title="$t('campaignDesigner.campaignSetup.sms')" v-if="campaignChannel.includes('sms')">
          <!-- SMS list -->
          <div class="row">
            <div class="slds-form-element col">
                <Spinner v-if="!gotAssetLists && (isCreate || isEdit)" style="scale:50%;" />
                <div v-if="gotAssetLists || !(isCreate || isEdit)" >
                  <Picklist
                  :label="$t('campaignDesigner.campaignSetup.sms_list')"
                  :options="sms_list"
                  :tooltip="$t('campaignDesigner.campaignSetup.sms_list_tooltip')"
                  tooltip-direction="right"
                  multipicklist
                  searchable
                  ref="sms_list"
                  v-if="(isCreate || isEdit)"
                  v-model="sms_selected" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.sms_list')"
                  :options="sms_selected"
                  :value="sms_selected"
                  type="multipicklist"
                  v-else />
                </div>
            </div>
          </div>
        </Card>

        <!-- UTM -->
        <Card additional-classes="slds-card_boundary slds-m-top--small" :title="$t('campaignDesigner.campaignSetup.email')" v-if="campaignChannel.includes('email')">
          <div class="row">
            <div class="slds-form-element col">
                <Spinner v-if="!gotAssetLists && (isCreate || isEdit)" style="scale:50%;" />
                <div v-if="gotAssetLists || !(isCreate || isEdit)" >
                <Picklist
                  :label="$t('campaignDesigner.campaignSetup.utm_list')"
                  :options="utm_list"
                  :tooltip="$t('campaignDesigner.campaignSetup.email_list_tooltip')"
                  tooltip-direction="right"
                  multipicklist
                  searchable
                  ref="utm_list"
                  v-if="(isCreate || isEdit)"
                  v-model="utm_selected" />

                  <OutputField
                  :label="$t('campaignDesigner.campaignSetup.utm_list')"
                  :options="utm_selected"
                  :value="utm_selected"
                  type="multipicklist"
                  v-else />
              </div>

            </div>
          </div>

          <!-- UTM Source -->
          <div class="row">
            <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.utm_source')"
                ref="utm_source"
                v-if="isCreate || isEdit"
                :disabled="true"
                v-model="utm_source_computed" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.utm_source')"
                :disabled="true"
                :value="utm_source_computed"
                v-else />
            </div>
          </div>
          </div>

          <!-- UTM Medium -->
          <div class="row">
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.utm_medium')"
                ref="utm_medium"
                v-if="isCreate || isEdit"
                :disabled="true"
                v-model="utm_medium_computed" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.utm_medium')"
                :disabled="true"
                :value="utm_medium_computed"
                v-else />
            </div>
          </div>
          </div>

          <!-- UTM Campaign -->
          <div class="row">
            <div class="slds-form-element col">
              <div class="slds-form-element slds-size--medium">
                <Input
                  :label="$t('campaignDesigner.campaignSetup.utm_campaign')"
                  ref="utm_campaign"
                  v-if="isCreate || isEdit"
                  :disabled="true"
                  v-model="utm_campaign" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.utm_campaign')"
                  :disabled="true"
                  :value="utm_campaign"
                  v-else />
              </div>
            </div>
          </div>

          <!-- UTM Content -->
          <div class="row">
            <div class="slds-form-element col">
              <div class="slds-form-element slds-size--medium">
                <Input
                  :label="$t('campaignDesigner.campaignSetup.utm_content')"
                  ref="utm_content"
                  v-if="isCreate || isEdit"
                  v-model="utm_content" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.utm_content')"
                  :value="utm_content"
                  v-else />
              </div>
            </div>
          </div>

        </Card>

      </Card>

      <transition name="fade">
        <Modal
          @close="showFleetWarning = false"
          @positiveButtonClick="showFleetWarning = false"
          :positive-button-text="$t('general.ok')"
          :title="$t('campaignDesigner.campaignSetup.fleetWarning.title')"
          v-if="showFleetWarning">

          <div class="slds-text-align_center">
            {{$t('campaignDesigner.campaignSetup.fleetWarning.text')}}
          </div>
        </Modal>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { getEmptyConfigByKey as getEmptyConfig } from '../../utils/indexedDbUtils'
import { validate } from '../../utils/utils'
import CampaignTypeSelector from './campaign-setup/CampaignTypeSelector'
import Card from '../../slds/Card'
import GenericFilter from '../../campaign-manager/filters/GenericFilter'
import HasMode from '../../utils/HasMode'
import Input from '../../slds/Input'
import Modal from '../../Modal'
import moment from 'moment'
import OutputField from '../../slds/OutputField'
import Picklist from '../../slds/Picklist'
import RadioGroup from '../../slds/RadioGroup'
import Spinner from '../../Spinner'
import TextArea from '../../slds/TextArea'
const util = require("util");



const CONTACT_PLAN_CT = [
  'Contact Plan',
  'Service Contact Plan'
]

const FLEET_CT = [
  'Fleet & Business - Newsletter',
  'Fleet & Business - Commerciali'
]

export default {
  name: 'CampaignSetup',
  mixins: [HasMode],
  components: {
    Card,
    CampaignTypeSelector,
    GenericFilter,
    Input,
    Modal,
    OutputField,
    Picklist,
    RadioGroup,
    Spinner,
    TextArea
  },
  beforeCreate () {
    this.$emit('startLoading')
  },
  created () {
    this.callLoadFromStore()
    this.$emit('endLoading')

  },
  beforeDestroy () {
    this.market_abr = undefined
    this.processtype = undefined
    this.campaigncategory = undefined
    this.businesstype = undefined
    this.sms_list = undefined
    this.push_list = undefined
    this.utm_list = undefined
    this.gotAssetLists = undefined
    this.utm_source_computed = undefined
    this.utm_medium_computed = undefined
    this.assetInfoConfig = undefined
    this.legacyexf = undefined
    this.legacyexp = undefined
    this.namecomputed = undefined
    this.sellingOnline = undefined
    this.business_area_options = undefined
    this.business_area = undefined
    this.utm_source = undefined
    this.utm_medium = undefined
    this.utm_campaign = undefined
    this.utm_content = undefined
    this.alwaysOn = undefined
    this.campaignBrands = undefined
    this.campaignChannel = undefined
    this.campaignType = undefined
    this.camperContribution = undefined
    this.ccCallsEndDate = undefined
    this.ccCallsStartDate = undefined
    this.ccExtractionDaysFreq = undefined
    this.ccMaxRecordsToExtract = undefined
    this.ccScript = undefined
    this.cscEngagementLevel = undefined
    this.contentClassification = undefined
    this.contributionType = undefined
    this.contributionTypeDefault = undefined
    this.deduplicationEnabled = undefined
    this.deduplicationCriteria = undefined
    this.deduplicationParameter = undefined
    this.deduplicationRadioOptions = undefined
    this.description = undefined
    this.disableOrchestration = undefined
    this.disableOrchestrationEditable = undefined
    this.endDate = undefined
    this.favorite = undefined
    this.finality = undefined
    this.fleetWarningShown = undefined
    this.localConfig = undefined
    this.markets = undefined
    this.masterKey = undefined
    this.name = undefined
    this.onlyHeader = undefined
    this.ppExtractionDaysFreq = undefined
    this.ppExtractionEndDate = undefined
    this.ppExtractionStartDate = undefined
    this.ppMaxRecordsToExtract = undefined
    this.ppProviderId = undefined
    this.ppTemplateFilename = undefined
    this.ppUrl1 = undefined
    this.ppUrl2 = undefined
    this.ppUrl3 = undefined
    this.seed = undefined
    this.segmentType = undefined
    this.legalBase = undefined
    this.showFleetWarning = undefined
    this.startDate = undefined
    this.touchpoint = undefined
    this.type = undefined
  },
  computed: {
    finalityTooltip () {
      if (this.recordType === 'sales') {
        return this.$t('campaignDesigner.campaignSetup.finality.tooltip.sales')
      } else {
        return this.$t('campaignDesigner.campaignSetup.finality.tooltip.afterSales')
      }
    },
    isCP () {
      return this.isContactPlan(this.campaignType.label)
    },
    ExFSalesMandatoryCheck () {
      return this.business_area === 'SALES'
    },
    ExFAfterSalesMandatoryCheck () {
      return this.business_area === 'AFTER_SALES'
    },
    isSales () {
      return this.recordType === 'sales'
    },
    isTechnical () {
      return this.recordType === 'technical'
    },
    isVHR () {
      return this.recordType === 'vhr'
    },
    getSelectedBrandAbbrArray() {
      let abbr_arr = []
      for(let i = 0; i < this.campaignBrands.length; i++) {
        abbr_arr.push(this.brand_abr.options[this.campaignBrands[i]])
      }
      return abbr_arr;
    },
    getSelectedMarketAbbrArray() {
      let abbr_arr = []
      for(let i = 0; i < this.markets.length; i++) {
        abbr_arr.push(this.market_abr.options[this.markets[i]])
      }
      return abbr_arr;
    },
    computeCampaignName () {
      if (this.isCreate || this.isEdit) {
        const regex = /[^a-zA-Z0-9]/g;
        const _bu = this.$store.getters['session/decodedAccessToken']['businessUnitId']
        let _businessunit = this.bu_abr.options[_bu] || _bu
        let _market = 'market'
        if (this.markets.length > 0) _market = this.markets.length == 1 ? this.market_abr.options[this.markets[0]] : 'multi'
        let _brand = 'brand'
        if (this.campaignBrands.length > 0) _brand = this.campaignBrands.length == 1 ? this.brand_abr.options[this.campaignBrands[0]].replace(regex, '') : 'multi'
        let _maintarget = this.maintarget
        let _label = (this.name == '') ? 'label' : this.name.replace(regex, '')
        let _businesstype = this.businesstype.replace(regex, '')
        let _campaigntype = this.campaignType.value == undefined ? 'camptype' : this.campaignType.value.replace(regex, '')
        let _category = this.campaigncategory ? this.campaigncategory.replace(regex, '') : 'category'

        this.namecomputed = _businessunit + '_' + _market + '_' + _brand + '_' + _maintarget + '_'
                                        + _label + '_' + _businesstype + '_' + _campaigntype + '_' + _category


      }
      //return this.namecomputed
    },
    isBusAreaAftersales() {
      return this.business_area === 'AFTER_SALES'
    },
    hasBrandExP() { //Check if brands picklist has these brands (PSA)
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      return this.campaignBrands.some(r=>(brandScopes[r] || []).includes('EXP'))
    },
    hasBrandExF() { //Check if brands picklist has these brands (FCA)
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      return this.campaignBrands.some(r=>(brandScopes[r] || []).includes('EXF'))
    }
  },
  data () {
    return {
      brand_user: undefined,
      brand_scopes: undefined,
      brandOptions: [],
      market_scopes: undefined,
      businessunit: '',
      bu_abr: undefined,
      brand_abr: undefined,
      market_abr: undefined,
      processtype: '',
      campaigncategory: [],
      businesstype: [],
      maintarget: [],
      sms_list: [],
      email_list: [],
      push_list: [],
      utm_selected: [],
      utm_list: [],
      gotAssetLists: false,
      assetInfoConfig: [],
      sms_selected: [],
      push_selected: [],
      utm_source_computed: 'sfmc',
      utm_medium_computed: 'email',
      legacyexf: undefined,
      legacyexp: undefined,
      namecomputed: '',
      sellingOnline: [],
      business_area_options: ["AFTER_SALES", "SALES"],
      business_area: '',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '<ID>',
      utm_content: '',
      alwaysOn: [],
      campaignBrands: [],
      campaignChannel: [],
      campaignType: {},
      camperContribution: false,
      ccdbReportEnabled: false,
      ccdbReportType: '',
      ccCallsEndDate: '',
      ccCallsStartDate: '',
      ccExtractionDaysFreq: '',
      ccMaxRecordsToExtract: '',
      ccScript: '',
      cscEngagementLevel: '',
      contentClassification: '',
      contributionType: '',
      contributionTypeDefault: '',
      deduplicationEnabled: false,
      deduplicationCriteria: '',
      deduplicationParameter: '',
      deduplicationRadioOptions: [
        {
          label: this.$t('campaignDesigner.targetDefinition.deduplication.deduplication'),
          value: 'deduplication'
        },
        {
          label: this.$t('campaignDesigner.targetDefinition.deduplication.sorting'),
          value: 'sorting'
        }
      ],
      description: '',
      disableOrchestration: false,
      disableOrchestrationEditable: true,
      endDate: '',
      favorite: false,
      finality: '',
      fleetWarningShown: false,
      jeepWave: '',
      localConfig: {},
      manager: '',
      markets: [],
      masterKey: '',
      masterKeys: [],
      name: '',
      oldCampaignChannel: [],
      onlyHeader: false,
      ppExtractionDaysFreq: '',
      ppExtractionEndDate: '',
      ppExtractionStartDate: '',
      ppMaxRecordsToExtract: '',
      ppProviderId: '',
      ppTemplateFilename: '',
      ppUrl1: '',
      ppUrl2: '',
      ppUrl3: '',
      recordType: '',
      seed: false,
      segmentType: '',
      legalBase: '',
      showFleetWarning: false,
      startDate: moment()._d,
      touchpoint: '',
      type: ''
    }
  },
  methods: {
    async callLoadFromStore () {
      this.brand_user = this.$store.getters['session/decodedAccessToken']['brands']
      this.localConfig = this.$store.getters['campaignDesigner/state'].currentCampaignConfig
      //console.log('LOCAL CONFIG', this.localConfig)
      const campaign = this.loadFromStore('campaignData', ['loading', 'oldConfig'])
      let brandCodes = this.localConfig.campaignData.brand_abr.options;
      let swapped = {};
      for(let key in brandCodes){ swapped[brandCodes[key]] = key; }
      brandCodes = swapped;
      for (let i = 0; i < this.brand_user.length; i++) {
        const brandName = this.brand_user[i];
        if (brandCodes[brandName]) {
          this.brand_user[i] = brandCodes[brandName];
        }
      }
      //Brand options are what we have from full/vhr.js + user filtering
      this.brandOptions = this.localConfig.campaignData.campaignBrands.options.filter(
        br => this.brand_user.includes(br)
      )
      if(campaign.brands) { //If we are viewing a campaign instead of a creating new campaign
        //Then make the selected brands the ones that we can only see
        this.campaignBrands = campaign.brands.filter(br => this.brandOptions.includes(br))
      }
      this.utm_campaign = '<ID>'
      if( campaign )
      {
         if (campaign.id) this.utm_campaign = campaign.id
         this.utm_selected = campaign.emailList ? campaign.emailList : []
         this.sms_selected = campaign.smsList ? campaign.smsList : []
         this.push_selected = campaign.pushList ? campaign.pushList : []
      }
      if (this.isCreate) this.business_area = 'AFTER_SALES'
      if (campaign.config.userPreferences && campaign.config.userPreferences.fleetWarningShown !== undefined) {
        this.fleetWarningShown = !!campaign.config.userPreferences.fleetWarningShown
      }
      if (this.$route.query.type) {
        this.onlyHeader = this.$store.getters['settings/settings'].campaignRecordTypes[this.$route.query.type].onlyHeader
        this.recordType = this.$route.query.type
      }
      this.market_scopes = this.localConfig.campaignData.market_scopes
      this.brand_scopes = this.localConfig.campaignData.brand_scopes
      if( this.isVHR && (this.isCreate || this.isEdit) ){
        this.campaigncategory = 'N'
        this.maintarget = 'all'
        this.segmentType = 'CUSTOMER'
        this.endDate = moment('2099-12-31','YYYY-MM-DD').toDate()
        this.alwaysOn = 'permanent'
      }
      if (this.localConfig.campaignData.masterKey && this.localConfig.campaignData.masterKey.options) {
        this.masterKeys = this.localConfig.campaignData.masterKey.options
      } else {
        this.masterKeys = (await this.$store.dispatch('settings/getSettings')).masterKeys
      }
      if (this.localConfig.campaignData.type.options.length === 1) {
        const selectedType = this.localConfig.campaignData.type.options[0]
        this.campaignType = {
          label: selectedType.name,
          value: selectedType.code,
          color: selectedType.color,
          disableOrchestrationFlagEditable: selectedType.disableOrchestrationFlagEditable,
          disableOrchestrationFlagDefault: selectedType.disableOrchestrationFlagDefault
        }
        this.disableOrchestration = selectedType.disableOrchestrationFlagDefault
      }
      if (campaign.config.campaignData && campaign.config.campaignData.type && campaign.config.campaignData.type.selected) {
        const selectedType = campaign.config.campaignData.type.selected
        this.campaignType = {
          label: selectedType.name,
          value: selectedType.code,
          color: selectedType.color,
          disableOrchestrationFlagEditable: selectedType.disableOrchestrationFlagEditable,
          disableOrchestrationFlagDefault: selectedType.disableOrchestrationFlagDefault
        }
      }
      if (this.deduplicationCriteria) {
        this.deduplicationEnabled = true
      }
      const emptyConfig = (await getEmptyConfig(this.onlyHeader ? 'HEADER' : 'FULL')).config
      this.contributionTypeDefault = emptyConfig.campaignData.contributionType.selected
      if (!this.contributionType) {
        this.contributionType = ''
      }
      this.$nextTick(() => {
        // Restore disable orchestration flag
        if (campaign.disableOrchestration !== undefined) {
          this.disableOrchestration = campaign.disableOrchestration
        }
        // Restore always on
        if (campaign.alwaysOn !== undefined) {
          this.alwaysOn = campaign.alwaysOn
        }
        if (campaign.config.campaignData.seed.selected !== undefined) {
          this.seed = campaign.config.campaignData.seed.selected == 'true'
        }
        if (campaign.config.campaignData.ccScript.selected !== undefined) {
          this.ccScript = campaign.config.campaignData.ccScript.selected
        }
      })
      this.assetInfoConfig = {};
      let PublishedAssetsIds = []
      const assetInfo = await this.$store.dispatch('campaignDesigner/getAssets')
      try {
        const PublishedAssets = await this.$store.dispatch('campaignDesigner/getPublishedAssets')
        PublishedAssetsIds = PublishedAssets[0].assets
        if (PublishedAssetsIds === undefined) throw new Error('Wrong published asset query')
      } catch(err) {
        console.error(err)
      }
      if (assetInfo && assetInfo.type) {
        for (let i = 0; i < assetInfo.type.length; i++)
        {
            if (PublishedAssetsIds.includes(assetInfo.id[i])) {
              continue;
            }
            let knownType = true;
            if (assetInfo.type[i] == 'email') {
              this.utm_list.push(assetInfo.computedName[i]);
            }
            else if (assetInfo.type[i] == 'sms') {
              this.sms_list.push(assetInfo.computedName[i]);
            }
            else if (assetInfo.type[i] == 'push') {
              this.push_list.push(assetInfo.computedName[i]);
            }
            else knownType = false
            if (knownType) {
              this.assetInfoConfig[ assetInfo.computedName[i] ] = {
                name: assetInfo.name[i],
                id: assetInfo.id[i],
                type: assetInfo.type[i],
                computedName: assetInfo.computedName[i],
                createdDate: assetInfo.createdDate[i],
                modifiedDate: assetInfo.modifiedDate[i],
                createdBy: assetInfo.createdBy[i],
                modifiedBy: assetInfo.modifiedBy[i],
                createdById: assetInfo.createdById[i],
                modifiedById: assetInfo.modifiedById[i]
              }
            }
        }
      }
        this.gotAssetLists = true
       // console.log("assetInfoConfig is ",assetInfo);
        if(this.isVHR && (this.isEdit || this.isCreate)) {
          this.campaignBrands = this.brandOptions.filter(br => ['066','083','000','077','057','070'].includes(br))
        }
    },
    getSectionToSave () {

      let assetFinal = [];
      let assetType = ['utm_selected', 'sms_selected', 'push_selected']
      for(let t=0; t<assetType.length; t++ ){
        for(let i=0;i<this[assetType[t]].length;i++){
          if( this.assetInfoConfig[ this[assetType[t]][i] ] ){
            assetFinal.push( this.assetInfoConfig[ this[assetType[t]][i] ] )
          }
        }
      }
      this.assetFinal = assetFinal


      const campaignType = {
        options: this.localConfig.campaignData.type.options,
        selected: this.localConfig.campaignData.type.options.find(type => type.code === this.campaignType.value)
      }

      let endDate = ''

      if (moment(this.endDate).isValid()) {
        endDate = moment(this.endDate).format('YYYY-MM-DD')
      }

      let ccCallsStartDate = ''
      let ccCallsEndDate = ''
      let ppExtractionStartDate = ''
      let ppExtractionEndDate = ''

      let contributionType

      if (moment(this.ccCallsStartDate).isValid()) {
        ccCallsStartDate = moment(this.ccCallsStartDate).format('YYYY-MM-DD')
      }

      if (moment(this.ccCallsEndDate).isValid()) {
        ccCallsEndDate = moment(this.ccCallsEndDate).format('YYYY-MM-DD')
      }

      if (moment(this.ppExtractionStartDate).isValid()) {
        ppExtractionStartDate = moment(this.ppExtractionStartDate).format('YYYY-MM-DD')
      }

      if (moment(this.ppExtractionEndDate).isValid()) {
        ppExtractionEndDate = moment(this.ppExtractionEndDate).format('YYYY-MM-DD')
      }

      if (this.contributionType) {
        contributionType = this.contributionType
      }

      const sectionToSave = {
        flat: {
          campaignChannel: this.campaignChannel,
          selected_market_abr: this.getSelectedMarketAbbrArray,
          selected_brand_abr: this.getSelectedBrandAbbrArray,
          businessunit: this.$store.getters['session/decodedAccessToken']['businessUnitId'],
          processtype: this.processtype,
          campaigncategory: this.campaigncategory,
          businesstype: this.businesstype,
          maintarget: this.maintarget,
          legacyexf: this.legacyexf,
          legacyexp: this.legacyexp,
          namecomputed: this.namecomputed,
          sellingOnline: this.sellingOnline,
          business_area: this.business_area || null,
          utm_source: this.utm_source_computed || null,
          utm_medium: this.utm_medium_computed || null,
          utm_campaign: this.utm_campaign || null,
          utm_content: this.utm_content || null,
          email_list: this.utm_selected || [],
          sms_list: this.sms_selected || [],
          push_list: this.push_selected || [],
          alwaysOn: this.alwaysOn,
          brands: this.campaignBrands,
          camperContribution: this.camperContribution,
          ccdbReportEnabled: this.ccdbReportEnabled,
          ccdbReportType: this.ccdbReportType,
          ccCallsEndDate,
          ccCallsStartDate,
          ccExtractionDaysFreq: this.ccExtractionDaysFreq,
          ccMaxRecordsToExtract: this.ccMaxRecordsToExtract,
          ccScript: this.ccScript || null,
          contentClassification: this.contentClassification,
          contributionType,
          cscEngagementLevel: this.cscEngagementLevel,
          description: this.description,
          disableOrchestration: this.disableOrchestration,
          finality: this.finality,
          marketCodes: this.markets,
          endDate,
          jeepWave: this.jeepWave,
          manager: this.manager,
          masterKey: this.masterKey,
          name: this.name,
          onlyHeader: this.onlyHeader,
          ppExtractionDaysFreq: this.ppExtractionDaysFreq,
          ppExtractionEndDate,
          ppExtractionStartDate,
          ppMaxRecordsToExtract: this.ppMaxRecordsToExtract,
          ppProviderId: this.ppProviderId,
          ppTemplateFilename: this.ppTemplateFilename,
          ppUrl1: this.ppUrl1,
          ppUrl2: this.ppUrl2,
          ppUrl3: this.ppUrl3,
          recordType: this.recordType,
          segmentType: this.segmentType,
          legalBase: this.legalBase,
          touchpoint: this.touchpoint,
          type: this.campaignType.value,
          startDate: moment(this.startDate).format('YYYY-MM-DD')
        },
        config: {
          market_scopes: this.market_scopes,
          brand_scopes: this.brand_scopes,
          brandOptions: this.brandOptions,
          bu_abr: this.bu_abr,
          brand_abr: this.brand_abr,
          market_abr: this.market_abr,
          assetInfo: this.assetFinal,
          processtype: {
            options: this.localConfig.campaignData.processtype.options,
            selected: this.processtype
          },
          maintarget: {
            options: this.localConfig.campaignData.maintarget.options,
            selected: this.maintarget
          },
          campaigncategory: {
            options: this.localConfig.campaignData.campaigncategory.options,
            selected: this.campaigncategory
          },
          businesstype: {
            options: this.localConfig.campaignData.businesstype.options,
            selected: this.businesstype
           },
          legacyexf: this.legacyexf,
          legacyexp: this.legacyexp,
          namecomputed: this.namecomputed,
          sellingOnline: {
            options: this.localConfig.campaignData.sellingOnline.options,
            selected: this.sellingOnline
           },
          alwaysOn: {
            options: this.localConfig.campaignData.alwaysOn.options,
            selected: this.alwaysOn
          },
          utm_source: this.utm_source_computed,
          utm_medium: this.utm_medium_computed,
          utm_campaign: this.utm_campaign,
          utm_content: this.utm_content,
          business_area: this.business_area,
          campaignBrands: {
            options: this.localConfig.campaignData.campaignBrands.options,
            selected: this.campaignBrands
          },
          campaignChannel: {
            options: this.localConfig.campaignData.campaignChannel.options,
            selected: this.campaignChannel
          },
          ccScript: {
            options: this.localConfig.campaignData.ccScript.options,
            selected: this.ccScript || null
          },
          contentClassification: {
            options: this.localConfig.campaignData.contentClassification.options,
            selected: this.contentClassification
          },
          contributionType: {
            options: this.localConfig.campaignData.contributionType.options,
            selected: contributionType || null
          },
          cscEngagementLevel: {
            options: this.localConfig.campaignData.cscEngagementLevel.options,
            selected: this.cscEngagementLevel
          },
          deduplicationCriteria: {
            options: this.localConfig.campaignData.deduplicationCriteria.options,
            selected: this.deduplicationCriteria
          },
          deduplicationParameter: {
            options: this.localConfig.campaignData.deduplicationParameter.options,
            selected: this.deduplicationParameter
          },
          disableOrchestrationEditable: this.disableOrchestrationEditable,
          description: this.description,
          favorite: {
            options: this.localConfig.campaignData.favorite.options,
            selected: this.favorite
          },
          finality: {
            options: this.localConfig.campaignData.finality.options,
            selected: this.finality
          },
          markets: {
            options: this.localConfig.campaignData.markets.options,
            selected: this.markets
          },
          masterKey: {
            selected: this.masterKey
          },
          seed: {
            options: this.localConfig.campaignData.seed.options,
            selected: this.seed
          },
          segmentType: {
            options: this.localConfig.campaignData.segmentType.options,
            selected: this.segmentType
          },
          type: campaignType
        },
        userPreferences: {
          fleetWarningShown: this.fleetWarningShown
        }
      }

      if (this.localConfig.campaignData.touchpoint) {
        sectionToSave.config.touchpoint = {
          options: this.localConfig.campaignData.touchpoint.options,
          selected: this.touchpoint
        }
      }

      if (this.isSales && this.localConfig.campaignData.manager) {
        sectionToSave.config.manager = {
          options: this.localConfig.campaignData.manager.options,
          selected: this.manager
        }
      }

      if (this.isSales && this.localConfig.campaignData.ccdbReportType) {
        sectionToSave.config.ccdbReportType = {
          options: this.localConfig.campaignData.ccdbReportType.options,
          selected: this.ccdbReportType
        }
      }

      if (this.localConfig.campaignData.jeepWave) {
        sectionToSave.config.jeepWave = {
          options: this.localConfig.campaignData.jeepWave.options,
          selected: this.jeepWave
        }
        sectionToSave.flat.jeepWave = this.jeepWave
      }

      if (this.localConfig.campaignData.legalBase) {
        sectionToSave.config.legalBase = {
            options: this.localConfig.campaignData.legalBase.options,
            selected: this.legalBase
          }
      }

      return sectionToSave
    },
    isContactPlan (ct) {
      return CONTACT_PLAN_CT.includes(ct)
    },
    isFleet (ct) {
      return FLEET_CT.includes(ct)
    },
    validate () {
      if (this.isCreate || this.isEdit) {
        return validate(this, 'data', true)
      } else {
        const dateFrom = moment(this.startDate, 'YYYY-MM-DD')
        if (this.campaignStatus === 'Draft' && dateFrom.isBefore(moment(), 'day')) {
          this.showToast('error', this.$t('validation.invalidData'), 'text', this.$t('campaignDesigner.campaignSetup.validation.startDateMustBeInFuture'))
        } else {
          return true
        }
      }
    }
  },
  props: {
    campaignStatus: String,
    loading: Boolean,
    mode: String
  },
  watch: {
    campaignBrands (newValue) {
      if (this.masterKeys.length) this.$refs.data_masterkey.clearValidationError()
      this.computeCampaignName
      if (!newValue.includes('077')) {
        this.camperContribution = false
      }
      if (!newValue.includes('057')) {
        this.jeepWave = ''
      }
      if (!this.hasBrandExF) {
        this.contributionType = ''
        this.contentClassification = ''
        this.touchpoint = ''
      }
    },
    campaignType: {
      handler (newValue, oldValue) {
        this.computeCampaignName
        if (this.isContactPlan(newValue.label)) {
          this.alwaysOn = 'permanent'
        } else if (this.isContactPlan(oldValue.label) && !this.isContactPlan(newValue.label)) {
          this.alwaysOn = 'one_time'
        }

        if (this.isCreate) {
          if (!this.fleetWarningShown && this.isFleet(newValue.label) && !this.isFleet(oldValue.label)) {
            this.showFleetWarning = true
            this.fleetWarningShown = true
          } else if (!this.isFleet(newValue.label) && this.isFleet(oldValue.label)) {
            this.fleetWarningShown = false
          }
        }

        this.disableOrchestrationEditable = newValue.disableOrchestrationFlagEditable
        this.disableOrchestration = this.recordType!='full' ? true : newValue.disableOrchestrationFlagDefault
        //console.log(this.disableOrchestration)
      },
      deep: true
    },
    campaignChannel (newValue) {
      if (!this.oldCampaignChannel.includes('email') && (this.isCreate)) {
        this.utm_selected = []
        // this.utm_campaign = ''
        // this.utm_medium = ''
        // this.utm_source = ''
      }
      if (!this.oldCampaignChannel.includes('push') && (this.isCreate)) {
        this.push_selected = []
      }
      if (!this.oldCampaignChannel.includes('sms') && (this.isCreate)) {
        this.sms_selected = []
      }
      if (!this.oldCampaignChannel.includes('call') && newValue.includes('call')) {
        this.ccScript = '0'
      } else if (this.oldCampaignChannel.includes('call') && !newValue.includes('call')) {
        this.ccScript = ''
      }
      this.oldCampaignChannel = _.cloneDeep(newValue)
    },
    deduplicationEnabled (newValue) {
      if (!newValue) {
        this.deduplicationCriteria = ''
        this.deduplicationParameter = ''

        this.$refs.data_deduplicationCriteria.clearValidationError()
        this.$refs.data_deduplicationParameter.clearValidationError()
      }
    },
    endDate () {
      //console.log(this.endDate)
      if (this.isCreate || this.isEdit) {
        this.$refs.data_startDate.clearValidationError()
      }
    },
    masterKey (value) {
      if (value === '') {
        this.masterKey = null
      }
    },
    name (value) {
      const regex = /[^a-zA-Z0-9]/g;
      this.name = value.replace(regex, '')
      this.computeCampaignName
    },
    markets (value) {
      //console.log('scopes:', this.market_scopes)
      if (this.markets.length == 0 || this.isVHR || !(this.isCreate || this.isEdit)) {
        // if (!this.brand_user) this.brandOptions = (this.localConfig.campaignData.brandOptions) ? this.localConfig.campaignData.brandOptions : this.localConfig.campaignData.campaignBrands.options
        // else
        if (!this.isVHR) {
          if (this.brand_user) this.brandOptions = this.brand_user.filter(
            br => this.localConfig.campaignData.campaignBrands.options.includes(br)
          )
          else this.brandOptions = this.localConfig.campaignData.campaignBrands.options
        }

      }
      else {
        this.brands = []
        this.campaignBrands = []
        let _scopes = new Set(); //Current selected market scopes (can be [exf], [exp] or [exf, exp])
        for (let i = 0; i < this.markets.length; i++) {
          const _market = this.market_scopes.options[this.markets[i]] //Returns array of current market scope, eg France -> [exF, exP]
          for(let j = 0; j < _market.length; j++) _scopes.add(_market[j]) //add all scope values of that array in the set
          if (_scopes.length == 2) break; //No need to look for more, both ExF and ExP are in
        }

        if (this.brand_user) this.brandOptions = this.brand_user.filter( (brand) => {
          const _scope = this.brand_scopes.options[brand][0] //get brand scope (exf or exp)
          return (_scopes.has(_scope)) //check if its included in current market(s) scope
        })
      }
      this.computeCampaignName
    },
    maintarget (value) {
      this.computeCampaignName
    },
    businesstype (value) {
      this.computeCampaignName
    },
    campaignType (newValue, oldValue) {
      if (this.isContactPlan(newValue.label)) {
          this.alwaysOn = 'permanent'
          this.endDate = moment('2099-12-31','YYYY-MM-DD').toDate()
        } else if (this.isContactPlan(oldValue.label) && !this.isContactPlan(newValue.label)) {
          this.alwaysOn = 'one_time'
        }
      this.computeCampaignName
      this.disableOrchestrationEditable = newValue.disableOrchestrationFlagEditable
      this.disableOrchestration = newValue.disableOrchestrationFlagDefault
      this.disableOrchestration = this.recordType!='full' ? true : newValue.disableOrchestrationFlagDefault
      //console.log(this.disableOrchestration)
      //this.$store.dispatch('campaignDesigner/changeAttrInCampaignData', { attrName:'disableOrchestrationEditable', attrVal: newValue.disableOrchestrationFlagEditable } )
    },
    campaigncategory (value) {
      this.computeCampaignName
    },
    business_area (value){
      if (this.onlyHeader && !this.isVHR) {
        if (this.masterKeys.length) this.$refs.data_masterkey.clearValidationError()
        if (this.contentClassification.options) this.$refs.data_contentClassification.clearValidationError()
        this.computeCampaignName
      }
    }

  }
}
</script>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .col {
    flex-grow: 1;
  }

  .type-color-container {
    margin-right: 10px;
  }

  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  Input {
    width: unset !important;
  }
</style>
